export function isJSXElement(object: any): object is JSX.Element {
  return (object as JSX.Element).props !== undefined;
}
